import { AlphaYBoxOutlineIcon } from './AlphaYBoxOutlineIcon';

/**
 * author: Contributors
 * id 929FF46B-C6B6-4973-BB7E-44C232F149AC
 * name alpha-y-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-y-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetYBoxOutlineIcon = AlphaYBoxOutlineIcon;
export default AlphabetYBoxOutlineIcon